import { Routes } from '@angular/router';
import { MainCampaignComponent } from "./main-campaign.component";

export const MainCampaignRoutes: Routes = [
    { path: '', component: MainCampaignComponent, pathMatch: 'full' }
];

